var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.RemindBindEmailShow,
          expression: "RemindBindEmailShow"
        }
      ],
      staticClass: "popup",
      staticStyle: { zIndex: "200" }
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "deleteRemind" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\r\n            " +
              _vm._s(_vm.$t("language.rightTopBanner.bindEmail")) +
              "\r\n            "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "email-remind-content" }, [
          _vm._v(
            "    \r\n            " +
              _vm._s(_vm.$t("language.paySystem.payFirst"))
          ),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("language.paySystem.paybindEmail"))
            },
            on: {
              click: function($event) {
                return _vm.openBindEmail()
              }
            }
          }),
          _vm._v(
            _vm._s(_vm.$t("language.paySystem.payEnd")) + "\r\n            "
          ),
          _c("div", { staticClass: "bind-remind-footer" }, [
            _c("div", { staticClass: "bind-button" }, [
              _c(
                "button",
                {
                  staticStyle: { "border-radius": "5Px" },
                  on: {
                    click: function($event) {
                      return _vm.openBindEmail()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
              )
            ]),
            _vm._v(" "),
            _c("div")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46a36017", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a36017","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/pay_system_popups/bind_email_topay_popup.vue
// module id = null
// module chunks = 